/*
 *@description: 批量上传组件
 */
<template>
  <div class="batch-compress-upload" tabindex="0">
    <!-- 上传区域 -->
    <div class="upload-area" v-show="!isView">
      <!-- 粘贴提示区域 -->
      <div class="paste-zone" v-if="fileListResAll.length === 0">
        <span class="paste-text">{{ $lang('可直接复制粘贴附件上传') }}</span>
      </div>

      <!-- 占位区域（有图片时撑开左边） -->
      <div class="spacer-zone" v-else></div>

      <!-- 已上传文件展示区域 -->
      <div class="files-zone" v-if="fileListResAll.length > 0">
        <div class="file-item"
             v-for="(item,index) of fileListResAll"
             :key="index">
          <!-- 图片预览 -->
          <img v-if="getFileTypeIcon(item) === 'hidden'"
               :src="item.downloadUrl"
               @click="showImg(item)">
          <span v-else class="file-icon">
            <i :class="'iconfont ' + getFileTypeIcon(item)"></i>
          </span>
          <!-- 删除按钮 -->
          <span class="file-close" @click.stop="fileDel(index)">
            <i class="el-icon-close"></i>
          </span>
        </div>
      </div>

      <!-- 上传按钮 -->
      <div class="upload-btn" v-show="currentLimit < limit" @click="fileClick">
        <i class="el-icon-plus"></i>
      </div>
    </div>

    <!-- 查看模式 -->
    <div class="view-area" v-if="isView && fileListResAll.length > 0">
      <div class="file-item"
           v-for="(item,index) of fileListResAll"
           :key="index">
        <img v-if="getFileTypeIcon(item) === 'hidden'"
             :src="item.downloadUrl"
             @click="showImg(item)">
        <span v-else class="file-icon" @click="handleDownload(item)">
          <i :class="'iconfont ' + getFileTypeIcon(item)"></i>
        </span>
      </div>
    </div>

    <!-- 隐藏的文件输入 -->
    <input name="files"
           style="display: none;"
           @change="fileChange($event)"
           type="file"
           ref="file"
           :multiple="multiple"
           :accept="nameTransformation(fileTypeList)">
  </div>
</template>

<script>
import fetch from '@/common/utils/serFetch';
import { RESPONSE_CODE } from '../@public/http/config';
import axios from 'axios'
import { imgRegular, imgRegularBase } from '@/common/utils/tool';
export default {
  name: 'BatchCompressUpload',
  data() {
    return {
      imgList: [],
      fileListResAll: [],
      currentLimit: 0,
      showViewer: false,
      urlList: []
    };
  },
  props: {
    isAll: Boolean,
    option: {
      type: Object,
      default() {
        return {
          projectName: '',
          moduleName: '',
          fileNames: ''
        }
      }
    },
    list: {
      type: Array,
      default: () => []
    },
    fileSize: {
      type: Number,
      default: () => 5
    },
    limit: {
      type: Number,
      default: () => 3
    },
    beforeUpload: {
      type: Function,
      default: () => { }
    },
    fileTypeList: {
      type: Array,
      default: () => ['png', 'pdf', 'jpg', 'jpeg', 'x-zip-compressed']
    },
    multiple: {
      type: Boolean,
      default: () => false
    },
    isView: {
      type: Boolean,
      default: () => false
    },
    isContinuityPreview: {
      type: Boolean,
      default: () => false
    },
    continuityPreviewList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    list: {
      handler(nVal, oVal) {
        this.fileListResAll = nVal
        this.currentLimit = this.fileListResAll.length
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    nameTransformation(list) {
      var newType = this.deepClone(list)
      const typeArr = {
        'docx': 'vnd.openxmlformats-officedocument.wordprocessingml.document',
        'doc': 'msword',
        'xls': 'application/vnd.ms-excel',
        'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'x-zip-compressed': 'application/zip,application/x-zip,application/x-zip-compressed',
        'pdf': 'application/pdf',
        'jpeg': 'image/jpeg',
        'jpg': 'image/jpeg',
        'gif': 'image/gif',
        'png': 'image/png'
      }
      for (var key in typeArr) {
        var val = newType.indexOf(key);
        val !== -1 && (newType[val] = typeArr[key]);
      }
      return this.isAll ? '*' : newType.join(',')
    },
    getFileTypeIcon(item) {
      const name = (item.path || item.downloadUrl).toLowerCase()
      if (name.match(imgRegular)) {
        return 'hidden'
      }
      if (name.indexOf('.pdf') > -1) {
        return 'iconPDF'
      }
      if (name.indexOf('.docx') > -1) {
        return 'icondocx1'
      }
      if (name.indexOf('.doc') > -1) {
        return 'icondoc1'
      }
      if (name.indexOf('.xls') > -1) {
        return 'icongonggaoguanli-wendang'
      }
      if (name.indexOf('.zip') > -1) {
        return 'iconyasuobao'
      }
      if (name.indexOf('.rar') > -1) {
        return 'iconRAR'
      }
      return 'icongonggaoguanli-wendang'
    },
    fileClick() {
      try {
        this.$refs.file.click();
      } catch (err) {
        console.error(err)
      }
    },
    fileChange(el) {
      if (this.beforeUpload && typeof (this.beforeUpload) === 'function') {
        this.beforeUpload()
      }
      if (!el.target.files[0].size) return
      this.fileList(el.target)
      el.target.value = ''
    },
    handleDownload: function(file) {
      const xhr = new XMLHttpRequest()
      xhr.open('GET', file.downloadUrl, true)
      xhr.responseType = 'blob'
      xhr.onload = () => {
        const url = URL.createObjectURL(xhr.response)
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', decodeURIComponent(file.name))
        document.body.appendChild(link)
        link.click()
        URL.revokeObjectURL(url)
        document.body.removeChild(link)
      }
      xhr.send()
    },
    async fileList(fileList) {
      const files = Array.from(fileList.files)
      const validFiles = files.filter(file => this.verifyFun(file))

      if (validFiles.length === 0) return

      const remaining = this.limit - this.currentLimit
      const actualValidFiles = validFiles.slice(0, Math.max(remaining, 0))

      if (actualValidFiles.length === 0) {
        this.$message.warning(this.$lang('已达到最大上传数量限制'))
        return
      }

      this.currentLimit += actualValidFiles.length
      this.$emit('uploadStart')

      try {
        const processedFiles = await Promise.all(
          actualValidFiles.map(async (file) => {
            const isImage = this.getFileTypeIcon({ downloadUrl: file.name }) === 'hidden'
            const isOver2M = file.size > 2 * 1024 * 1024
            if (isImage && isOver2M) {
              return await this.compressImage(file)
            }
            return file
          })
        );

        const validProcessedFiles = processedFiles.filter(file => {
          if (this.getFileTypeIcon({ downloadUrl: file.name }) === 'hidden') {
            const compressedSize = file.size / 1024 / 1024;
            if (compressedSize >= this.fileSize) {
              this.$message.error(this.$lang(`文件${file.name}压缩后仍超过${this.fileSize}MB!`))
              return false
            }
          }
          return true
        })

        const actualCount = validProcessedFiles.length
        this.currentLimit = this.currentLimit - (actualValidFiles.length - actualCount)

        validProcessedFiles.forEach(file => {
          this.fileAdd(file)
          this.uploadFile(file)
        })

        if (actualCount > 0 && validFiles.length <= actualValidFiles.length) {
          this.$message.success(this.$lang(`已开始上传${actualCount}个文件`))
        }
        if (actualCount > 0 && validFiles.length > actualValidFiles.length) {
          const skipped = validFiles.length - actualValidFiles.length
          this.$message.success(this.$lang(`已开始上传${actualCount}个文件；因达到最大限制，${skipped}个文件未上传`))
        }
      } catch (error) {
        this.$message.error(this.$lang('文件处理失败，请重新上传'))
        this.currentLimit -= actualValidFiles.length
      }
    },
    async uploadFile(option) {
      const name = option.name
      const filterName = name.substring(0, name.lastIndexOf('.')).replace(/[\ |\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?/\，/\。/\；/\：/\“/\”/\》/\《/\|/\{/\}/\、/\!/\~/\`]/g, '')
      const suffixName = name.substring(name.lastIndexOf('.'))
      const paramsName = filterName + suffixName
      const { moduleName, projectName } = this.option;

      const fileSize = option.size

      const param = {
        projectName: projectName || 'ylbpo',
        moduleName: moduleName || this.$route.name,
        size: fileSize,
        fileNames: paramsName
      };
      const uploadApi = this.option.url || `bpo/file/getUploadSignedUrl`
      const { code, data, msg } = await fetch.get(uploadApi, { params: param })
      if (!code && code !== 0) {
        this.$message.error(this.$lang('文件上传功能异常，请联系客服'))
        return
      }
      if (code !== RESPONSE_CODE.SUCCESS_COPY || !data) {
        this.$message.error(msg || this.$lang('文件上传功能异常，请联系客服'))
        return
      }
      const res = {
        ...data[0],
        contentType: data[0].contentType,
        url: data[0].url.replace('http:', window.location.protocol),
        config: { headers: { 'Content-Type': data[0].contentType }}
      }
      this.httpRequest(res, option)
    },
    async httpRequest(list, option) {
      const resData = await axios.put(list.url, option, list.config)
      if ((resData || {}).status === 200) {
        this.fileListResAll.push({ ...option, ...list, ...{ name: option.name, size: option.size }})
        if (this.fileListResAll.length === this.currentLimit) {
          this.$message.success(this.$lang('上传成功'))
        }
      }
      this.$emit('uploadSuccess', this.fileListResAll)
    },
    verifyFun(file) {
      const fileType = file.name.replace(/[\S\s]+\.(\S+)$/, '$1')
      const isRtTy = !this.fileTypeList.length || this.fileTypeList.includes(fileType)
      const isLtRuleSize = file.size / 1024 / 1024 < this.fileSize
      if (!isLtRuleSize) {
        this.$message.closeAll()
        this.$message.error(this.$lang('上传大小不能超过' + this.fileSize + 'MB!'))
        return false
      }
      if (this.currentLimit >= this.limit) {
        this.$message.warning(`${this.$lang('最多只能上传')} ${this.limit}${this.$lang('个文件')}`)
        return false
      }
      if (!isRtTy) {
        this.$message.warning(`${this.$lang('只能上传') + this.fileTypeList.join(' ') + this.$lang('格式')}`)
        return false
      }
      return true
    },
    fileAdd(file) {
      const reader = new FileReader()
      reader.vue = this
      reader.readAsDataURL(file)
      reader.onload = function () {
        file.downloadUrl = this.result
        this.vue.imgList = file
      }
    },
    fileDel(index) {
      this.fileListResAll.splice(index, 1)
      this.currentLimit--
      this.$emit('uploadRemove', this.fileListResAll)
    },
    reset() {
      this.fileListResAll = []
      this.currentLimit = 0
    },
    handlePaste(event) {
      if (this.isView) return

      const items = event.clipboardData && event.clipboardData.items
      if (!items) return

      const files = []
      for (let i = 0; i < items.length; i++) {
        const item = items[i]
        if (item.type.indexOf('image') !== -1) {
          const blob = item.getAsFile()
          if (blob) {
            const timestamp = new Date().getTime()
            const ext = item.type.replace('image/', '') || 'png'
            const fileName = `paste_${timestamp}.${ext}`
            const file = new File([blob], fileName, { type: item.type })
            files.push(file)
          }
        }
      }

      if (files.length > 0) {
        event.preventDefault()

        if (this.currentLimit >= this.limit) {
          this.$message.warning(`${this.$lang('最多只能上传')} ${this.limit}${this.$lang('个文件')}`)
          return
        }

        const mockFileList = { files: files }
        this.fileList(mockFileList)
      }
    },
    showImg(data) {
      const list = []
      if (this.isContinuityPreview) {
        this.continuityPreviewList.forEach(item => {
          if (item?.length) {
            item.forEach(img => {
              if (img?.downloadUrl?.match(imgRegularBase) || img?.downloadUrl?.match(imgRegular)) {
                list.push(img.downloadUrl)
              }
            })
          }
        })
      } else {
        this.fileListResAll.forEach(item => {
          if (item?.downloadUrl?.match(imgRegularBase)) {
            list.push(item.downloadUrl)
          }
        })
      }
      const index = list.findIndex(item => item === data.downloadUrl)
      this.$openImagePreview(list, index)
    },
    async compressImage(file) {
      return new Promise((resolve) => {
        if (this.getFileTypeIcon({ downloadUrl: file.name }) !== 'hidden') {
          resolve(file)
          return
        }

        const reader = new FileReader()
        reader.onload = (e) => {
          const img = new Image()
          img.src = e.target.result
          img.onload = () => {
            const canvas = document.createElement('canvas')
            const ctx = canvas.getContext('2d')

            const maxSize = 1024
            let width = img.width
            let height = img.height

            if (width > height && width > maxSize) {
              height *= maxSize / width
              width = maxSize
            } else if (height > maxSize) {
              width *= maxSize / height
              height = maxSize
            }

            canvas.width = width
            canvas.height = height
            ctx.drawImage(img, 0, 0, width, height)

            canvas.toBlob((blob) => {
              const compressedFile = new File([blob], file.name, {
                type: 'image/jpeg',
                lastModified: Date.now()
              })
              console.log('压缩前:', (file.size / 1024 / 1024).toFixed(2) + 'MB', '压缩后:', (compressedFile.size / 1024 / 1024).toFixed(2) + 'MB')
              resolve(compressedFile)
            }, 'image/jpeg', 0.9)
          };
        };
        reader.readAsDataURL(file)
      })
    }
  },
  mounted() {
    this.$el.addEventListener('paste', this.handlePaste)
  },
  beforeDestroy() {
    this.$el.removeEventListener('paste', this.handlePaste)
  },
  destroyed() {
    this.fileListResAll = []
  }
}
</script>

<style scoped lang="scss">
.batch-compress-upload {
  outline: none;
  width: 100%;
  margin-top: 10px;
}

// 上传区域 - 横向布局
.upload-area {
  display: flex;
  align-items: stretch;
  min-height: 90px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;

  // 粘贴提示区域
  .paste-zone {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 0 16px;
    cursor: pointer;
    background-color: #fff;
    transition: all 0.3s;

    &:hover {
      background-color: #f5f7fa;
    }

    .paste-text {
      font-size: 14px;
      color: #c0c4cc;
    }
  }

  // 占位区域
  .spacer-zone {
    flex: 1;
    background-color: #fff;
  }

  // 文件展示区域
  .files-zone {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    gap: 10px;
    overflow-x: auto;
    background-color: #fff;
    flex-shrink: 0;

    .file-item {
      position: relative;
      width: 70px;
      height: 70px;
      flex-shrink: 0;
      border-radius: 4px;
      overflow: visible;
      border: 1px solid #ebeef5;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        cursor: pointer;
        border-radius: 4px;
      }

      .file-icon {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #f5f7fa;
        cursor: pointer;
        border-radius: 4px;

        i {
          font-size: 28px;
          color: #909399;
        }
      }

      .file-close {
        position: absolute;
        top: -6px;
        right: -6px;
        width: 18px;
        height: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(0, 0, 0, 0.6);
        border-radius: 50%;
        cursor: pointer;
        opacity: 0;
        transition: opacity 0.3s;
        z-index: 10;

        i {
          font-size: 10px;
          color: #fff;
        }

        &:hover {
          background-color: rgba(0, 0, 0, 0.8);
        }
      }

      &:hover {
        .file-close {
          opacity: 1;
        }
      }
    }
  }

  // 上传按钮
  .upload-btn {
    width: 90px;
    min-width: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: #fafafa;
    border-left: 1px solid #dcdfe6;
    transition: all 0.3s;

    &:hover {
      background-color: #f5f7fa;

      i {
        color: #409eff;
      }
    }

    i {
      font-size: 24px;
      color: #c0c4cc;
      font-weight: 300;
      transition: color 0.3s;
    }
  }
}

// 查看模式
.view-area {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  min-height: 90px;

  .file-item {
    width: 70px;
    height: 70px;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #ebeef5;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      cursor: pointer;
    }

    .file-icon {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #f5f7fa;
      cursor: pointer;

      i {
        font-size: 28px;
        color: #909399;
      }
    }
  }
}
</style>
